import {Routes} from '@angular/router';
import {LoginComponent} from "./login/login.component";
import {DashboardComponent} from "./dashboard/dashboard.component";
import {LoggedInActivator} from "./services/CheckSessionActivator";
import {InternalOnlyActivator} from "./services/InternalOnlyActivator";
import {FormulaTestCaseListComponent} from "./formula-tools/formula-test-case-list/formula-test-case-list.component";
import {FormulaSandboxComponent} from "./formula-tools/formula-sandbox/formula-sandbox.component";
import {ManageBillingComponent} from "./header-components/manage-billing/manage-billing.component";
import {ManageFirmLogoComponent} from "./header-components/manage-firm-logo/manage-firm-logo.component";
import {ManageUsersComponent} from "./header-components/manage-users/manage-users.component";
import {ManageUserProfileComponent} from "./header-components/manage-user-profile/manage-user-profile.component";
import {ManageIntegrationsComponent} from "./header-components/manage-integrations/manage-integrations.component";
import {ClientsComponent} from "./sidebar-components/clients/clients.component";
import {ClientInfoComponent} from "./sidebar-components/client-info/client-info.component";
import {TaxStrategiesListComponent} from "./sidebar-components/tax-strategies/tax-strategies-list/tax-strategies-list.component";
import {ViewTaxStrategyComponent} from "./sidebar-components/tax-strategies/view-tax-strategy/view-tax-strategy.component";
import {TemplatesListComponent} from "./sidebar-components/templates/templates-list/templates-list.component";
import {VendorsListComponent} from "./sidebar-components/vendors/vendors-list/vendors-list.component";
import {CreateOrUpdateVendorComponent} from "./sidebar-components/vendors/create-or-update-vendor/create-or-update-vendor.component";
import {ViewVendorComponent} from "./sidebar-components/vendors/view-vendor/view-vendor.component";
import {TaxlabComponent} from "./sidebar-components/taxlab/taxlab.component";
import {ManageFirmsComponent} from "./header-components/manage-firms/manage-firms.component";
import {FirmCreationComponent} from "./header-components/firm-creation/firm-creation.component";
import {ReportsComponent} from "./header-components/reports/reports.component";
import {UserHistoryReportComponent} from "./header-components/reports/user-history-report/user-history-report.component";
import {TasksDashboardComponent} from "./sidebar-components/tasks-dashboard/tasks-dashboard.component";
import {ClientPlanInfoComponent} from "./sidebar-components/client-plan-info/client-plan-info.component";
import {GrowthPlanComponent} from "./sidebar-components/growth-plan/growth-plan.component";
import {EventsComponent} from "./sidebar-components/events/events.component";
import {AnnouncementsComponent} from "./sidebar-components/announcements/announcements.component";
import {QuestionnairesListComponent} from "./sidebar-components/questionnaires-list/questionnaires-list.component";
import {CreateQsComponent} from "./questionnaires/create-qs/create-qs.component";
import {TermsComponent} from "./terms/terms.component";
import {ChangePasswordComponent} from "./change-password/change-password.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {ManageUserBillingComponent} from './manage-user-billing/manage-user-billing-component';
import {ManageSubscriptionComponent} from './header-components/manage-subscription/manage-subscription.component';
import {SignupComponent} from "./signup/signup.component";
import {AutoLoginComponent} from "./signup/auto-login/auto-login.component";
import {OnboardDashboardComponent} from "./signup/onboard-dashboard/onboard-dashboard.component";
import {onboardingGuard} from "./signup/onboard-dashboard/onboarding.guard";
import {WallDashBoardActivator} from "./services/WallDashboardActivator";
import {TodosComponent} from "./sidebar-components/todos/todos.component";
import {TodoSinglePageComponent} from "./sidebar-components/todos/todo-single-page/todo-single-page.component";
import {TaskSinglePageComponent} from "./sidebar-components/tasks-dashboard/task-single-page/task-single-page.component";
import {CustomerDashboardComponent} from "./customer-app/customer-dashboard/customer-dashboard.component";
import {CustomerTaxPlanningComponent} from "./customer-app/customer-tax-planning/customer-tax-planning.component";
import {CustomerTaxEstimatesComponent} from "./customer-app/customer-tax-estimates/customer-tax-estimates.component";
import {TaskTodosComponent} from "./sidebar-components/tasks-dashboard/task-todos/task-todos.component";
import { DrawerComponent } from './customer-app/customer-dashboard/todos/drawer.component';
import {ClientAnswersQsComponent} from "./questionnaires/client-answers/client-answers-qs/client-answers-qs.component";
import { PublicChallengeComponent } from './public-challenge/public-challenge.component';
import { PublicQuestionnaireFormComponent } from './questionnaires/public-form/public-questionnaire-form.component';
import {ProjectionDetailComponent} from "./sidebar-components/projection-detail/projection-detail.component";
import { HandoffComponent } from './handoff/handoff.component';
import { ChoosePlatformComponent } from './choose-platform/choose-platform.component';

export const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'handoff',
    component: HandoffComponent
  },
  {
    // Phase 1a post-login interstitial — shown to feature-flag-eligible,
    // Growth-tier users so they can pick Tax Planning vs Tax Projections.
    // login.component.ts routes here when eligible; otherwise users skip
    // straight to /tpiq/dashboard.
    path: 'choose-platform',
    component: ChoosePlatformComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'activate',
    component: ChangePasswordComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'resetpassword/:token',
    component: ResetPasswordComponent,
    canActivate: [WallDashBoardActivator]
  },
  {
    path: 'tax-planning/terms',
    component: TermsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/manage-billing',
    component: ManageUserBillingComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/manage-subscription',
    component: ManageSubscriptionComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tpiq/dashboard',
    component: DashboardComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tpiq/onboard',
    component: OnboardDashboardComponent,
    canActivate: [LoggedInActivator],
    canDeactivate: [onboardingGuard]
  },
  {
    path: 'tax-planning/manageBilling',
    component: ManageBillingComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/manage-logo',
    component: ManageFirmLogoComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/manage-users',
    component: ManageUsersComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/profile',
    component: ManageUserProfileComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/integrations',
    component: ManageIntegrationsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/clients',
    component: ClientsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/clients/:type',
    component: ClientsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/clients/:clientId/:action',
    component: ClientInfoComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/client/:clientId/projections/:projectionSetId',
    component: ProjectionDetailComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/client/:clientId/:taxPlanningId/:taxPlanyear/:planView',
    component: ClientPlanInfoComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/taxStrategies',
    component: TaxStrategiesListComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/taxStrategies/:strategyId/:action',
    component: ViewTaxStrategyComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/taxStrategies/:strategyId',
    component: ViewTaxStrategyComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/templates',
    component: TemplatesListComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/vendors',
    component: VendorsListComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/create-vendor',
    component: CreateOrUpdateVendorComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/vendor/:vendorId',
    component: CreateOrUpdateVendorComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/vendor/:vendorId/view',
    component: ViewVendorComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/taxlab',
    component: TaxlabComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/manage-firms',
    component: ManageFirmsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/firm-creation',
    component: FirmCreationComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/reports',
    component: ReportsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/user-history-report',
    component: UserHistoryReportComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tasks',
    component: TasksDashboardComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/growth-plan',
    component: GrowthPlanComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/events',
    component: EventsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tpiq/announcements',
    component: AnnouncementsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/organizer',
    component: QuestionnairesListComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/manage-questionnaire',
    component: CreateQsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'signup',
    component: SignupComponent,
    canActivate: [WallDashBoardActivator]
  },
  {
    path: 'signup/:plan',
    component: SignupComponent,
    canActivate: [WallDashBoardActivator]
  },
  {
    path: 'auto-login',
    component: AutoLoginComponent,
    canActivate: [WallDashBoardActivator]
  },
  {
    path: 'signup/:plan/:couponcode',
    component: SignupComponent,
    canActivate: [WallDashBoardActivator]
  },
  {
    path: 'tax-planning/todos',
    component: TodosComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: ':channelType/:channelId/:channelName/toDo/:id/singlepage',
    component: TodoSinglePageComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: ':channelType/:channelId/toDo/:id/singlepage',
    component: TodoSinglePageComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: ':channelType/:channelId/task/:taskId/singlePage',
    component: TaskSinglePageComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/customer-tax-planning',
    component: CustomerTaxPlanningComponent,
    canActivate: [LoggedInActivator]
  }, {
    path: 'tax-planning/customer/dashboard',
    component: CustomerDashboardComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'tax-planning/tax-estimates',
    component: CustomerTaxEstimatesComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'toDo/:type',
    component: TaskTodosComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: 'client-single-todo/:channelType/:channelId/toDo/:todoId',
    component: DrawerComponent,
    canActivate: [LoggedInActivator],
     outlet: 'popup'
  },
  {
    path: 'tax-planning/questionnaire-response',
    component: ClientAnswersQsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    path: ':channelType/:channelId/questionnaire-response/:qId/:qName',
    component: ClientAnswersQsComponent,
    canActivate: [LoggedInActivator]
  },
  {
    // external taxpayer form — no guard: the token is the credential and the
    // taxpayer has no login (CU-868kg6qux)
    path: 'questionnaire-form/:token',
    component: PublicQuestionnaireFormComponent
  },
  { path: '10-days-tax-plan-challenge',
    component: PublicChallengeComponent,
    canActivate: [WallDashBoardActivator]
  },
  {
    path: 'tools/formula-test-cases',
    component: FormulaTestCaseListComponent,
    canActivate: [InternalOnlyActivator]
  },
  {
    path: 'tools/formula-sandbox',
    component: FormulaSandboxComponent,
    canActivate: [InternalOnlyActivator]
  },
];
